import React, { useContext, useEffect, useState } from "react";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";

import { useSelector } from "react-redux";
import UiContext from "../../../../../store/ui-context";
import useAPIRequest from "../../../../../custom_hooks/simple/useAPIRequest";
import { DataTable } from "primereact/datatable";
import {
    genTemplateBodyText,
} from "../../../../../components/utils/TableTemplateBodyGenerator";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { format } from "date-fns";
import ProblemKendaraanEditorDialog from "../../../../problem/components/dialogs/ProblemEditorDialog";
import PreviewImageDialog from "../../../../problem/components/dialogs/ProblemPreviewImageDialog";
import { Dialog } from "primereact/dialog";
import { genElObject } from "../../../../../components/utils/EditorDialogElementGenerator";
import KendaraanSelectorDialog from "../../../../../dialogs/selectors/KendaraanSelectorDialog";
import useIsMobile from "../../../../../hooks/useIsMobile";

// const title = "Problem Kendaraan";
const fetchOrderBy = "tanggal";
const fetchOrderMethod = "DESC";
const apiUrl = "problemkendaraan";


const ProblemCheck = (props, { className }) => {
  const isMobile = useIsMobile();
    const uiContext = useContext(UiContext);
    const { visible, onHide, onNewAudit } = props;
    const permissions = useSelector((state) => state.auth.permissions);
    const { requestGet, requestGetOne, requestDelete, loading } =
        useAPIRequest();

    const { loading: editorLoading, requestPost: editorRequestPost } =
        useAPIRequest();

    const [firstLoad, setFirstLoad] = useState(false);
    const [paging, setPaging] = useState({
        page: 1,
        take: 10000,
        filter: "",
        total: 0,
        with_kendaraan: 1,
        with_trailer: 1,
    });
    const [listData, setListData] = useState([]);
    const [selectedData, setSelectedData] = useState([]);

    const [filterValue, setFilterValue] = useState({});
    const [showProblemDialog, setShowProblemDialog] = useState(false);

    const [pagingNew, setPagingNew] = useState({
        page: 1,
        take: 10,
        filter: "",
        total: 0,
        with_kendaraan: 1,
        with_trailer: 1,
    });
    const [listDataNew, setListDataNew] = useState([]);

    const [permittedToEdit, setPermittedToEdit] = useState(false);
    const [addNewMode, setAddNewMode] = useState(false);
    const [editorData, setEditorData] = useState({});
    const [editorError, setEditorError] = useState({});
    const [editorDialogShowed, setEditorDialogShowed] = useState(false);
    const [showImagePreview, setShowImagePreview] = React.useState(false);

    // useEffect section

    useEffect(() => {
        // console.log("PERMISSION TO EDIT");
        updatePermittedToEdit();
    }, [permissions]);

    // API call section

    const fetchListData = async ({ page, take, filter, showFinished }) => {
        if (loading) return;

        const _filter = filter;
        filter += `${showFinished ? "" : "tanggal_selesai:=:Null"}`;

        return requestGet({
            fullUrl: `/api/problem/${apiUrl}/data`,
            params: {
                page: page,
                take: take,
                filter: _filter,
                order: fetchOrderBy,
                order_method: fetchOrderMethod,
                with_kendaraan: 1,
                with_trailer: 1,
                with_di_tangani: 1,
                "with_pengecekan_mobil_detil,data_pengecekan_mobil": 1,
                "with_audit_kendaraan_detil,data_audit_kendaraan": 1,
            },
            onSuccess: ({ pagination, message, data }) => {
                setPaging({
                    ...paging,
                    total: pagination["total"],
                    page: pagination["page"],
                    take: pagination["take"],
                    filter: _filter,
                });
                setListData(
                    data.map((el, index) => ({
                        ...el,
                        no: (page - 1) * take + index + 1,
                    }))
                );
                if (!firstLoad) {
                    setFirstLoad(true);
                }
            },
            onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
        });
    };

    const fetchData = async ({ id }) => {
        if (loading) return;
        return requestGetOne({
            fullUrl: `/api/problem/${apiUrl}/one/${id}`,
            onSuccess: ({ message, data }) => { },
            onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
        });
    };

    const deleteData = async ({ ids }) => {
        if (loading) return;

        return requestDelete({
            fullUrl: `/api/problem/${apiUrl}/delete`,
            ids: ids,
            onSuccess: ({ message, data }) => {
                const foundInNew = listDataNew.find((el) => ids.includes(el.id));
                if (foundInNew) {
                    const newListData = listDataNew.filter((el) => !ids.includes(el.id));
                    setListDataNew(newListData);
                } else {
                    const newListData = listData.filter((el) => !ids.includes(el.id));
                    setListData(newListData);
                }

                uiContext.showSuccessMsg("Success", message);
            },
            onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
        });
    };

    const saveData = async ({ data }) => {
        resetEditorError();
        if (loading) return;
        const valid = validateData();

        if (valid) {
            const body = convertSaveData(data);

            return editorRequestPost({
                fullUrl: `/api/problem/${apiUrl}/save`,
                body,
                isForm: false,
                onError: ({ message, data }) => {
                    uiContext.showErrorMsg("Error", message);
                    setEditorError(data);
                },
                onSuccess: ({ data, message }) => {
                    uiContext.showSuccessMsg("Success", message);
                    // fetchListData(paging);
                },
            });
        }
        return null;
    };

    // methods & functions section

    const updatePermittedToEdit = () => {
        // authorize to permit edit
        let _permittedToEdit = false;
        if (
            permissions &&
            (permissions.includes("view it") ||
                permissions.includes("update kabag-transport") ||
                permissions.includes("update pnj-transport") ||
                permissions.includes("update pnj") ||
                permissions.includes("update adm-transport"))
        ) {
            _permittedToEdit = true;
        }
        setPermittedToEdit(_permittedToEdit);
    };

    const resetEditorError = () => {
        setEditorError({});
    };

    const validateData = () => {
        let valid = true;
        return valid;
    };

    const convertSaveData = (data) => {
        return data;
    };

    // handle UI events section

    const handleOnReload = async (showFinished) => {
        setPaging({ ...paging, filter: `kendaraan_id:=:${filterValue.kendaraan_id};tanggal_selesai:=:Null` });
        fetchListData({
            page: 1,
            take: 10000,
            filter: `kendaraan_id:=:${filterValue.kendaraan_id};tanggal_selesai:=:Null`,
        });

        setPagingNew({ ...pagingNew, filter: `kendaraan_id:=:${filterValue.kendaraan_id};tanggal_selesai:=:Null` });
    };

    const handleOnDelete = (row) => {
        resetEditorError();
        const accept = async () => {
            if (loading) return;

            await deleteData({ ids: [row.id] });
        };
        const reject = () => { };

        confirmDialog({
            message: "Menghapus 1 data, lanjutkan?",
            header: "Konfirmasi",
            icon: "pi pi-exclamation-triangle",
            acceptClassName: "p-button-danger",
            accept,
            reject,
        });
    };

    const handleOnEdit = async (row) => {
        setAddNewMode(false);
        resetEditorError();
        const newData = await fetchData({ id: row.id });
        if (newData) {
            setEditorData({ ...newData });
            setEditorDialogShowed(true);
        }
    };

    const handleConfirmEditor = async (data) => {
        const newData = await saveData({ data });
        if (newData) {
            if (addNewMode) {
                setListData([newData, ...listData]);
            } else {
                const indexInNew = listDataNew.findIndex((el) => el.id === newData.id);
                if (indexInNew >= 0) {
                    const newListData = [...listDataNew];
                    newListData.splice(indexInNew, 1, newData);
                    setListDataNew(newListData);
                } else {
                    const index = listData.findIndex((el) => el.id === newData.id);
                    const newListData = [...listData];
                    newListData.splice(index, 1, newData);
                    setListData(newListData);
                }
            }
            setEditorDialogShowed(false);
        }
    };

    const handleOnClickImage = (row) => {
        setEditorData({ ...row });
        setShowImagePreview(true);
    };

    const handleOnClickShowPengecekan = (row) => {
        if (
            row.data_pengecekan_mobil_detil &&
            row.data_pengecekan_mobil_detil.data_pengecekan_mobil &&
            row.data_pengecekan_mobil_detil.data_pengecekan_mobil.pemakaian_mobil_id
        ) {
            const id =
                row.data_pengecekan_mobil_detil.data_pengecekan_mobil
                    .pemakaian_mobil_id;
            if (id > 0) {
                let url = `/transaksi/cek-keluar-masuk/kembali/${id}`;
                window.open(url, "_blank");
            }
        }
        if (
            row.data_audit_kendaraan_detil &&
            row.data_audit_kendaraan_detil.audit_kendaraan_id
        ) {
            const id =
                row.data_audit_kendaraan_detil.audit_kendaraan_id;
            if (id > 0) {
                let url = `/audit/audit-kendaraan/edit/${id}`;
                window.open(url, "_blank");
            }
        }
    };

    // UI section

    /**
     * Generate Table Column
     *
     * various function to generate
     * genTemplateBodyAction({ row, onEdit, onDelete })
     * genTemplateBodyText({ row, field, defaultEmpty })
     * genTemplateBodyNumber({ row, field, defaultEmpty, maxFraction, minFraction })
     * genTemplateBodyDate({ row, field, format })
     * genTemplateBodyImage({ row, field })
     */
    const actionBodyTemplate = (row) => {
        // console.log(row);

        return (
            <div className="row-center-center gap-2">
                <Button
                    disabled={!permittedToEdit}
                    icon="pi pi-pencil"
                    rounded
                    severity="success"
                    className="bg-emerald-400 max-w-[1.85rem] max-h-[1.85rem]"
                    onClick={() => {
                        handleOnEdit(row);
                    }}
                    pt={{ icon: { className: "!text-xs" } }}
                />
                <Button
                    disabled={!permittedToEdit}
                    icon="pi pi-trash"
                    rounded
                    severity="danger"
                    className="bg-red-400 max-w-[1.85rem] max-h-[1.85rem]"
                    onClick={() => {
                        handleOnDelete(row);
                    }}
                    pt={{ icon: { className: "!text-xs" } }}
                />

                <Button
                    icon="pi pi-image"
                    disabled={!row.gambar}
                    rounded
                    className="max-w-[1.85rem] max-h-[1.85rem]"
                    onClick={() => {
                        handleOnClickImage(row);
                    }}
                    pt={{ icon: { className: "!text-xs" } }}
                />

                <Button
                    icon="pi pi-check"
                    rounded
                    className="max-w-[1.85rem] max-h-[1.85rem]"
                    onClick={() => {
                        handleOnClickShowPengecekan(row);
                    }}
                    pt={{ icon: { className: "!text-xs" } }}
                />
            </div>
        );
    };
    // genTemplateBodyAction({
    //   row,
    //   onEdit: (row) => handleOnEdit(row),
    //   onDelete: handleOnDelete,
    // });

    const kendaraanInfo = (row) => {
        if (row.data_trailer && row.data_trailer.nomor) {
            return { nomor: row.data_trailer.nomor, jenis: "Trailer" };
        }
        if (row.data_kendaraan) {
            return {
                nomor: row.data_kendaraan.nomor_polisi || "-",
                jenis: row.data_kendaraan.jenis_mobil || "-",
            };
        }
        return { nomor: "-", jenis: "-" };
    };


    const kendaraanCellTemplate = (row) => {
        const info = kendaraanInfo(row);
        return (
            <div>
                <div className="font-semibold">{info.nomor}</div>
                <div>{info.jenis}</div>
            </div>
        );
    };

    const keteranganBodyTemplate = (row) =>
        genTemplateBodyText({ row, field: "keterangan" });
    const noteBodyTemplate = (row) => genTemplateBodyText({ row, field: "note" });
    const showDashboardBodyTemplate = (row) => {
        if (row.show_dashboard) {
            return <i className="pi pi-check text-green-500" />;
        } else {
            return <i className="pi pi-times text-red-500" />;
        }
    };
    const groupLabelTemplate = (row) => {
        if (row.label_grup && row.label_grup.length > 0) {
            let _labelGrup = row.label_grup.replaceAll("_", " ");
            _labelGrup = _labelGrup.charAt(0).toUpperCase() + _labelGrup.slice(1);
            return _labelGrup;
        }
        return "";
    };

    const tanggalBodyTemplate = (row) => {
        return (
            <div className="col-center-center">
                <span
                    className={`${row.tanggal_selesai ? "text-sm font-semibold" : ""}`}
                >
                    {row.tanggal ? format(new Date(row.tanggal), "dd/MM/yyyy") : "-"}
                </span>
                {row.tanggal_selesai && (
                    <span className={`text-sm font-semibold text-green-500`}>
                        {format(new Date(row.tanggal_selesai), "dd/MM/yyyy")}
                    </span>
                )}
            </div>
        );
    };

    const durasiBodyTemplate = (row) => {
        let dayCountToToday = 0;
        const toDate = row.tanggal_selesai
            ? new Date(row.tanggal_selesai)
            : new Date();
        dayCountToToday = Math.floor(
            (toDate - new Date(row.tanggal)) / (1000 * 60 * 60 * 24)
        );
        return `${dayCountToToday.toLocaleString("id-ID")} hari`;
    };

    const diTanganiBodyTemplate = (row) => {
        return (
            <div className="flex flex-col">
                <div>{row.data_di_tangani ? row.data_di_tangani.nama : "-"}</div>
                <div className="text-sm">{row.di_tangani_datetime}</div>
            </div>
        );
    };

    const descriptionMobileBodyTemplate = (rowData) => {
        const { tanggal_selesai, data_kendaraan, data_trailer, data_di_tangani } =
            rowData;

        let dayCountToToday = 0;
        dayCountToToday = Math.floor(
            (new Date() - new Date(rowData?.tanggal)) / (1000 * 60 * 60 * 24)
        );

        let _labelGrup =
            rowData?.label_grup && rowData?.label_grup.length > 0
                ? rowData?.label_grup.replace("_", " ")
                : "";
        _labelGrup = _labelGrup.charAt(0).toUpperCase() + _labelGrup.slice(1);
        _labelGrup += " - ";

        return (
            <>
                <div className="col-start-start px-3 py-2">
                    {data_trailer && (
                        <span className="font-semibold">
                            {data_trailer?.nomor} - TRAILER
                        </span>
                    )}
                    {data_kendaraan && (
                        <span className="font-semibold">
                            {data_kendaraan?.nomor_polisi} - {data_kendaraan?.jenis_mobil}
                        </span>
                    )}
                    {rowData?.tanggal && (
                        <div className="row-start-center gap-3 py-2">
                            <span className="text-xs italic font-semibold text-slate-400">
                                {format(new Date(rowData?.tanggal), "dd/MM/yyyy")}
                            </span>
                            {tanggal_selesai && (
                                <span className="text-xs italic font-semibold text-slate-400">
                                    {" "}
                                    s/d
                                </span>
                            )}
                            {tanggal_selesai && (
                                <span className="text-xs italic font-semibold text-slate-400">
                                    {format(new Date(rowData?.tanggal_selesai), "dd/MM/yyyy")}
                                </span>
                            )}
                            <span className="text-xs italic font-semibold text-slate-400">
                                {dayCountToToday > 0 ? `(${dayCountToToday} hari)` : ""}
                            </span>
                        </div>
                    )}
                    <span>{_labelGrup + rowData?.keterangan}</span>
                    {/* <span>
                        {rowData?.show_dashboard ? (
                            <span className="text-sm italic font-semibold text-slate-400">
                                Showed on Dashboard
                            </span>
                        ) : (
                            <span className="text-sm italic font-semibold text-slate-400">
                                Not Showed on Dashboard
                            </span>
                        )}
                    </span> */}
                    <span className="text-sm italic font-semibold text-slate-400 pb-2">
                        {rowData?.note}
                    </span>
                    {data_di_tangani && (
                        <span className="text-xs italic font-semibold text-slate-400">
                            Ditangani: {data_di_tangani.nama} (
                            {rowData?.di_tangani_datetime
                                ? format(new Date(rowData?.di_tangani_datetime), "dd/MM/yyyy")
                                : "?"}
                            )
                        </span>
                    )}
                    <div className="gap-2 w-full grid grid-cols-2">
                        <Button
                            icon="pi pi-trash"
                            label="Delete"
                            text
                            severity="danger"
                            className="!py-1 !px-2"
                            onClick={() => handleOnDelete(rowData)}
                        />
                        {rowData.gambar && (
                            <Button
                                icon="pi pi-image"
                                label="Foto"
                                text
                                className="!py-1 !px-2"
                                onClick={() => handleOnClickImage(rowData)}
                            />
                        )}
                        <Button
                            icon="pi pi-pencil"
                            label="Edit"
                            text
                            className="!py-1 !px-2"
                            onClick={() => handleOnEdit(rowData)}
                        />

                        <Button
                            icon="pi pi-check"
                            label="Lihat Cek"
                            text
                            className="!py-1 !px-2"
                            onClick={() => handleOnClickShowPengecekan(rowData)}
                        />
                    </div>
                </div>
            </>
        );
    };

    const [showKendaraanSelector, setShowKendaraanSelector] = useState(false);

    const handleOnClickKendaraan = () => {
        setShowKendaraanSelector(true);
    };

    const handleOnConfirmKendaraan = (event, datas) => {
        event.preventDefault();
        if (datas && datas.length > 0) {
            const selected = datas[0];
            setFilterValue({
                ...filterValue,
                data_kendaraan: selected,
                kendaraan_id: selected.id, // ✅ add this line
            });
            setShowKendaraanSelector(false);
        }
    };

    const filterElVehicle = genElObject({
        name: "Kendaraan",
        field: "data_kendaraan",
        value:
            filterValue && filterValue.data_kendaraan
                ? `${filterValue.data_kendaraan.nomor_polisi} | ${filterValue.data_kendaraan.jenis_mobil}`
                : "",
        width: "w-[20rem]",
        onClick: handleOnClickKendaraan,
        onClear: () => setFilterValue({ ...filterValue, data_kendaraan: null }),
    });

    return (
        <>
            <KendaraanSelectorDialog
                title={"Pilih Kendaraan"}
                visible={showKendaraanSelector}
                additionalFilter="data_kendaraan_jenis.nama:=:Trado"
                onHide={() => setShowKendaraanSelector(false)}
                onConfirm={handleOnConfirmKendaraan}
            />

            <Dialog
                visible={visible}
                onHide={onHide}
                style={{ width: "23rem" }}
                header="Check Problem Kendaraan"
                closable
            >
                <div className="col-start-end gap-4 w-full">
                    <div className="row-start-end w-full">
                        {filterElVehicle}
                    </div>

                    <div className="row-end-center">
                        <Button
                            label="Tutup"
                            icon="pi pi-times"
                            outlined
                            className="mt-4"
                            onClick={onHide}
                        />
                        <Button
                            label="Check"
                            icon="pi pi-external-link"
                            className="mt-4 ml-2"
                            onClick={async () => {
                                if (!filterValue.kendaraan_id) {
                                    uiContext.showErrorMsg("Error", "Silakan pilih kendaraan terlebih dahulu.");
                                    return;
                                }

                                const response = await fetchListData({
                                    page: 1,
                                    take: 10000,
                                    filter: `kendaraan_id:=:${filterValue.kendaraan_id};tanggal_selesai:=:Null`,
                                });

                                // check what the API returned
                                if (response && response.length > 0) {
                                    // if there are problems, open dialog
                                    setShowProblemDialog(true);
                                } else {
                                    // no problems found — go to new audit
                                    uiContext.showSuccessMsg("Success", "Tidak ada masalah ditemukan. Lanjut ke audit kendaraan.");
                                    setTimeout(() => {
                                        onNewAudit?.(filterValue.data_kendaraan);
                                    }, 3000);
                                }
                            }}
                        />
                    </div>
                </div>
            </Dialog>

            <Dialog
                visible={showProblemDialog}
                onHide={() => {
                    setShowProblemDialog(false);
                    setListData([]); // optional
                }}

                style={{ width: "auto" }}
                header={`${`${listData.length} Problem Kendaraan belum selesai`}`}
                closable
                footer={
                    <div className="flex justify-end gap-2">
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            outlined
                            onClick={() => setShowProblemDialog(false)}
                        />
                        <Button
                            label="Selesai"
                            icon="pi pi-check"
                            className="bg-emerald-500 text-white"
                            onClick={async () => {
                                const response = await fetchListData({
                                    page: 1,
                                    take: 10000,
                                    filter: `kendaraan_id:=:${filterValue.kendaraan_id};tanggal_selesai:=:Null`,
                                });

                                if (response?.length > 0) {
                                    uiContext.showErrorMsg(
                                        "Masih Ada Problem",
                                        "Buka Audit Kendaraan Form"
                                    );
                                } else {
                                    uiContext.showSuccessMsg(
                                        "Semua Problem Selesai",
                                        "Buka Audit Kendaraan Form"
                                    );
                                    setShowProblemDialog(false);
                                }
                                setTimeout(() => {
                                    onNewAudit?.(filterValue.data_kendaraan);
                                }, 1000);
                            }}
                        />
                    </div>
                }
            >
                <div className={`col-start-start gap-4 w-100`}>
                    <ConfirmDialog />
                    <PreviewImageDialog
                        data={editorData}
                        visible={showImagePreview}
                        onHide={(e) => setShowImagePreview(false)}
                    />
                    <ProblemKendaraanEditorDialog
                        data={editorData}
                        setData={setEditorData}
                        addNewMode={addNewMode}
                        loading={editorLoading}
                        error={editorError}
                        setError={setEditorError}
                        visible={editorDialogShowed}
                        onHide={() => setEditorDialogShowed(false)}
                        onConfirm={handleConfirmEditor}
                    />

                    {/* TABEL PROBLEM LAMA */}
                    <div className="col-center-center w-100 gap-3">
                        <div className={`row-between-center gap-2 w-full`}>
                            <span className="text-base font-semibold text-zinc-700">
                                Problem Yang Belum Selesai
                            </span>
                            <Button
                                rounded
                                outlined
                                icon="pi pi-refresh"
                                onClick={() => handleOnReload({})}
                                style={{ width: "40px", height: "40px" }}
                            />
                        </div>

                        <div className={`row-center-center gap-2 w-100`}>
                            <DataTable
                                sortMode="multiple"
                                dataKey="id"
                                className="w-100"
                                loading={loading}
                                showGridlines
                                stripedRows
                                editMode="cell"
                                value={listData}
                                selection={selectedData}
                                onSelectionChange={(e) => setSelectedData(e.value)}
                                rowClassName={(data) => {
                                    if (data.tanggal_selesai) return "bg-green-50";
                                    return "bg-white";
                                }}
                            >
                                <Column
                                    sortable
                                    header="#"
                                    field="no"
                                    headerClassName="w-[2.5rem]"
                                    className="text-right"
                                    alignHeader={"right"}
                                />

                                {isMobile && (
                                    <Column
                                        header="DESKRIPSI"
                                        headerClassName="text-xs"
                                        className="!p-0"
                                        alignHeader={"left"}
                                        body={descriptionMobileBodyTemplate}
                                    />
                                )}

                                {/* <Column headerClassName="w-[3rem]" selectionMode={"multiple"} /> */}

                                {!isMobile && (
                                    <Column
                                        header="Action"
                                        alignHeader={"center"}
                                        headerClassName="w-[9rem]"
                                        body={actionBodyTemplate}
                                    />
                                )}

                                {!isMobile && (
                                    <Column
                                        sortable
                                        field="tanggal"
                                        header="Tanggal"
                                        body={tanggalBodyTemplate}
                                    />
                                )}

                                {!isMobile && (
                                    <Column
                                        field="durasi"
                                        header="Durasi"
                                        body={durasiBodyTemplate}
                                    />
                                )}

                                {!isMobile && (
                                    <Column
                                        sortable
                                        field="data_kendaraan.nomor_polisi"
                                        header="Kendaraan"
                                        // headerClassName="w-[10rem]"
                                        body={kendaraanCellTemplate}
                                    />
                                )}

                                {/* {!isMobile && (
                                    <Column
                                        sortable
                                        field="data_kendaraan.jenis_kendaraan"
                                        header="Jenis"
                                        // headerClassName="w-[10rem]"
                                        body={jenisBodyTemplate}
                                    />
                                )} */}

                                {!isMobile && (
                                    <Column
                                        sortable
                                        field="label_grup"
                                        header="Group"
                                        body={groupLabelTemplate}
                                    />
                                )}

                                {!isMobile && (
                                    <Column
                                        sortable
                                        field="keterangan"
                                        header="Keterangan"
                                        body={keteranganBodyTemplate}
                                    />
                                )}

                                {!isMobile && (
                                    <Column
                                        sortable
                                        field="show_dashboard"
                                        header="Show Dashboard"
                                        body={showDashboardBodyTemplate}
                                    />
                                )}

                                {!isMobile && (
                                    <Column
                                        sortable
                                        field="note"
                                        header="Note"
                                        body={noteBodyTemplate}
                                    />
                                )}

                                {!isMobile && (
                                    <Column
                                        sortable
                                        field="di_tangani_id"
                                        header="Di tangani"
                                        body={diTanganiBodyTemplate}
                                    />
                                )}
                            </DataTable>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default ProblemCheck;
